import React from 'react';
import { FieldError } from '../../core';

import { cn } from '@/libs';
import { uiConfig } from '@/config';

import { FormFieldMapper } from '..';
import { Checkbox, Input } from '../inputs';
import { config } from '../../config';
import { useClearOnNotApplicable, useNotApplicableField } from '../../hooks';
import { FileFormField } from '../../typings';
import { FormFieldAlertMessage } from './FormFieldAlertMessage';

import './FilePresenter.scss';

interface FilePresenterProps {
  field: FileFormField;
  disabled?: boolean;
}

export const FilePresenter: React.FC<FilePresenterProps> = ({
  field,
  disabled,
}) => {
  const containerClasses = field.size
    ? cn('file__container', uiConfig.grid.maxColumnsSpanClass)
    : undefined;

  const isFieldNA = useNotApplicableField(field.notApplicableField?.fieldId);

  useClearOnNotApplicable(field, isFieldNA);

  return (
    <div id={field.fieldId} className={containerClasses}>
      {field.alertMessage && (
        <FormFieldAlertMessage alertMessage={field.alertMessage} />
      )}
      <Input.File
        label={field.label}
        required={field.minFileCount > 0}
        name={field.name}
        disabled={isFieldNA || disabled || field.readonly}
        previousFiles={field.fileNames}
        maxFiles={field.maxFileCount}
        maxSize={field.restriction?.maxFileSizeInBytes}
        accept={field.restriction?.acceptedFileTypes}
      />
      {field.notApplicableField !== undefined && (
        <Checkbox
          name={field.notApplicableField.fieldId}
          label={field.notApplicableField.label}
          size="small"
          disabled={disabled || field.readonly}
        />
      )}

      {isFieldNA && field.naDetails && (
        <FormFieldMapper field={field.naDetails} disabled={disabled} />
      )}

      <FieldError
        name={`${field.fieldId}${config.minFilesCountFieldSuffix}`}
      />
    </div>
  );
};
